import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import qs from 'qs';

export const query = gql`
  query GetUserThirdPartyPurchasesAdmin(
    $input: GetUserThirdPartyPurchasesAdminInput!
  ) {
    getUserThirdPartyPurchasesAdmin(input: $input) {
      count
      yearCounts {
        year
        count
      }
      results {
        id
        fee
        refund
        discount
        credit
        total
        profit
        purchase_date
        status
        order_source
        payment_method
        user {
          id
          first_name
          last_name
          email
          cellphone
        }
        users {
          user {
            id
            name
            first_name
            last_name
            email
            cellphone
          }
          tickets {
            id
            name
            price
            refunded
            credited
            type
          }
        }
        event {
          id
          name
          start_date
          end_date
          status
          tickets {
            id
            name
            price
          }
        }
        track {
          id
          name
        }
      }
    }
  }
`;

export default graphql(query, {
  options: ({ match, location }) => {
    const search = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    // Extract third-party specific params
    const input = {
      user_id: Number(match.params.id),
      ...search,
    };

    // Convert year to number if present and it's for third party
    if (input.thirdPartyYear) {
      input.year = Number(input.thirdPartyYear);
      delete input.thirdPartyYear;
    }

    // Also convert year to number if it came directly from URL params
    if (input.year && typeof input.year === 'string') {
      input.year = Number(input.year);
    }

    // Convert page to offset
    if (input.thirdPartyPage) {
      const page = Number(input.thirdPartyPage);
      input.offset = (page - 1) * 15; // 15 items per page
      input.limit = 15;
      delete input.thirdPartyPage;
    }

    return {
      variables: {
        input,
      },
      fetchPolicy: 'cache-and-network',
    };
  },
  name: 'thirdPartyData', // Use a different name to avoid conflicts with transaction data
});
